var module = angular.module('octopusApp.configuration', []);

module.config(function($stateProvider, stateHelperProvider) {
    $stateProvider.state("app.configuration", {
        url: '/configuration',
        templateUrl: 'areas/configuration/views/configuration_layout.html',
        layout: {
            tab: 'configuration'
        },
        defaultSubRoute: 'app.configuration.overview'
    });

    $stateProvider.state("app.configuration.overview", {
        url: '',
        controller: 'ConfigurationIndexController'
    });

    //Audit
    {
        $stateProvider.state('app.configuration.audit', {
            url: '/audit',
            template: stateHelperProvider.withBreadcrumb('Audit', '#/configuration/audit'),
            layout: {
                configTab: 'audit'
            },
            defaultSubRoute: 'app.configuration.audit.list'
        });

        $stateProvider.state('app.configuration.audit.list', {
            url: '',
            templateUrl: 'areas/configuration/audit/views/index.html',
            controller: 'AuditIndexController',
            controllerAs: 'vm',
            layout: {
                title: 'Audit'
            }
        });
    }

    //Subscriptions
    {
        $stateProvider.state('app.configuration.subscriptions', {
            url: '/subscriptions',
            template: stateHelperProvider.withBreadcrumb('Subscriptions', '#/configuration/subscriptions'),
            defaultSubRoute: 'app.configuration.subscriptions.list'
        });

        $stateProvider.state('app.configuration.subscriptions.list', {
            url: '',
            templateUrl: 'areas/configuration/subscriptions/views/index.html',
            controller: 'SubscriptionsController',
            layout: {
                title: 'Subscriptions',
                configTab: 'subscriptions'
            }
        });

        $stateProvider.state('app.configuration.subscriptions.new', {
            url: '/new',
            templateUrl: 'areas/configuration/subscriptions/views/create.html',
            controller: 'SubscriptionEditController',
            controllerAs: 'vm',
            bindToController: true,
            layout: {
                title: 'New Subscription',
                configTab: 'subscriptions'
            }
        });

        $stateProvider.state('app.configuration.subscriptions.edit', {
            url: '/:subscriptionId',
            templateUrl: 'areas/configuration/subscriptions/views/edit.html',
            controller: 'SubscriptionEditController',
            controllerAs: 'vm',
            bindToController: true,
            layout: {
                title: 'Edit Subscription',
                configTab: 'subscriptions'
            }
        });
    }

    $stateProvider.state('app.configuration.backup', {
        url: '/backup',
        templateUrl: 'areas/configuration/backup/views/edit.html',
        controller: 'BackupEditController',
        layout: {
            title: 'Backup',
            configTab: 'backup'
        }
    });

    $stateProvider.state('app.configuration.certificates', {
        url: '/certificates',
        templateUrl: 'areas/configuration/certificates/views/index.html',
        controller: 'CertificateConfigurationController',
        layout: {
            title: 'Certificates',
            configTab: 'certificates'
        }
    });

    //Diagnostics
    {
        $stateProvider.state('app.configuration.diagnostics', {
            url: '/diagnostics',
            templateUrl: 'areas/configuration/diagnostics/views/layout.html',
            layout: {
                configTab: 'diagnostics'
            },
            defaultSubRoute: 'app.configuration.diagnostics.serverlogs'
        });

        $stateProvider.state('app.configuration.diagnostics.serverlogs', {
            url: '',
            templateUrl: 'areas/configuration/diagnostics/views/server_logs.html',
            controller: 'DiagnosticsIndexController',
            controllerAs: 'vm',
            layout: {
                title: 'Diagnostics - Server Logs',
                diagnosticTab: 'serverLogs'
            }
        });

        $stateProvider.state('app.configuration.diagnostics.detailedserverlogs', {
            url: '/logs',
            views: {
                "@app.configuration": {
                    templateUrl: 'areas/configuration/diagnostics/views/logs.html',
                    controller: 'DiagnosticsLogsController'
                }
            },
            layout: {
                title: 'Diagnostics - Auto Deploy Logs'
            }
        });

        $stateProvider.state('app.configuration.diagnostics.environmentcleanup', {
            url: '/environment_cleanup',
            templateUrl: 'areas/configuration/diagnostics/views/scheduled_task.html',
            controller: 'DiagnosticsScheduledTaskController',
            layout: {
                title: 'Diagnostics - Environment Cleanup',
                diagnosticTab: 'environmentCleanupLogs'
            },
            data: {
                scheduledTaskName: 'CleanUnavailableMachines'
            }
        });

        $stateProvider.state('app.configuration.diagnostics.autodeploy', {
            url: '/auto_deployment_activity',
            templateUrl: 'areas/configuration/diagnostics/views/scheduled_task.html',
            controller: 'DiagnosticsScheduledTaskController',
            layout: {
                title: 'Diagnostics - Auto Deployment',
                diagnosticTab: 'autoDeploymentLogs'
            },
            data: {
                scheduledTaskName: 'ProcessAutoDeployments'
            }
        });

        $stateProvider.state('app.configuration.diagnostics.subscript', {
            url: '/subscription_activity',
            templateUrl: 'areas/configuration/diagnostics/views/scheduled_task.html',
            controller: 'DiagnosticsScheduledTaskController',
            layout: {
                title: 'Diagnostics - Subscription Activity',
                diagnosticTab: 'subscriptionLogs'
            },
            data: {
                scheduledTaskName: 'ProcessSubscriptions'
            }
        });
    }

    $stateProvider.state('app.configuration.features', {
        url: '/features',
        templateUrl: 'areas/configuration/features/views/edit.html',
        controller: 'FeaturesEditController',
        layout: {
            title: 'Features',
            configTab: 'features'
        }
    });

    $stateProvider.state('app.configuration.license', {
        url: '/license',
        templateUrl: 'areas/configuration/license/views/index.html',
        controller: 'LicenseIndexController',
        layout: {
            title: 'License',
            configTab: 'license'
        }
    });

    $stateProvider.state('app.configuration.maintenance', {
        url: '/maintenance',
        templateUrl: 'areas/configuration/maintenance/views/edit.html',
        controller: 'MaintenanceEditController',
        layout: {
            title: 'Maintenance',
            configTab: 'maintenance'
        }
    });

    $stateProvider.state('app.configuration.nodes', {
        url: '/nodes',
        templateUrl: 'areas/configuration/nodes/views/index.html',
        controller: 'NodesIndexController',
        layout: {
            title: 'Nodes',
            configTab: 'nodes'
        }
    });

    $stateProvider.state('app.configuration.nodeconfig', {
        url: '/nodes/config',
        templateUrl: 'areas/configuration/nodes/config/views/edit.html',
        controller: 'ServerEditController',
        layout: {
            title: 'Nodes',
            configTab: 'nodes'
        }
    });

    $stateProvider.state('app.configuration.smtp', {
        url: '/smtp',
        templateUrl: 'areas/configuration/smtp/views/edit.html',
        controller: 'SmtpEditController',
        layout: {
            title: 'SMTP Configuration',
            configTab: 'smtp'
        }
    });

    // Teams
    {
        $stateProvider.state('app.configuration.teams', {
            url: '/teams',
            template: stateHelperProvider.withBreadcrumb('Teams', '#/configuration/teams'),
            layout: {
                title: 'Teams',
                configTab: 'teams'
            },
            defaultSubRoute: 'app.configuration.teams.list'
        });

        $stateProvider.state('app.configuration.teams.list', {
            url: '',
            templateUrl: 'areas/configuration/teams/views/index.html',
            controller: 'TeamIndexController'
        });

        $stateProvider.state('app.configuration.teams.new', {
            url: '/new',
            templateUrl: 'areas/configuration/teams/views/edit.html',
            controller: 'TeamEditController',
            layout: {
                title: 'New Team'
            }
        });

        $stateProvider.state('app.configuration.teams.test', {
            url: '/test',
            templateUrl: 'areas/configuration/teams/views/test.html',
            controller: 'TeamTestController',
            layout: {
                title: 'Test Permissions'
            }
        });

        $stateProvider.state('app.configuration.teams.edit', {
            url: '/:id',
            templateUrl: 'areas/configuration/teams/views/edit.html',
            controller: 'TeamEditController',
            layout: {
                title: 'Edit Team'
            }
        });
    }

    // Roles
    {
        $stateProvider.state('app.configuration.teams.roles', {
            url: '^/configuration/roles',
            template: stateHelperProvider.withBreadcrumb('User Roles', '#/configuration/roles'),
            layout: {
                title: 'User Roles'
            },
            defaultSubRoute: 'app.configuration.teams.roles.list'
        });

        $stateProvider.state('app.configuration.teams.roles.list', {
            url: '',
            templateUrl: 'areas/configuration/roles/views/index.html',
            controller: 'UserRoleIndexController'
        });

        $stateProvider.state('app.configuration.teams.roles.create', {
            url: '/new',
            templateUrl: 'areas/configuration/roles/views/edit.html',
            controller: 'UserRoleEditController',
            layout: {
                title: 'New User Role'
            }
        });

        $stateProvider.state('app.configuration.teams.roles.edit', {
            url: '/:id',
            templateUrl: 'areas/configuration/roles/views/edit.html',
            controller: 'UserRoleEditController',
            layout: {
                title: 'Edit User Role'
            }
        });
    }

    // Users
    {
        $stateProvider.state('app.configuration.users', {
            url: '^/configuration/users',
            template: stateHelperProvider.withBreadcrumb('Users', '#/configuration/users'),
            layout: {
                title: 'Users',
                configTab: 'users'
            },
            defaultSubRoute: 'app.configuration.users.list'
        });

        $stateProvider.state('app.configuration.users.list', {
            url: '',
            templateUrl: 'areas/configuration/users/views/index.html',
            controller: 'UsersIndexController'
        });

        $stateProvider.state('app.configuration.users.new', {
            url: '/new',
            templateUrl: 'areas/configuration/users/views/create.html',
            controller: 'UserEditController',
            layout: {
                title: 'Create User'
            }
        });

        $stateProvider.state('app.configuration.users.invite', {
            url: '/invite',
            templateUrl: 'areas/configuration/users/views/invite.html',
            controller: 'UsersInviteController',
            layout: {
                title: 'Invite User'
            }
        });

        $stateProvider.state('app.configuration.users.edit', {
            url: '/:id',
            templateUrl: 'areas/configuration/users/views/edit.html',
            controller: 'UserEditController',
            layout: {
                title: 'Edit User'
            }
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/configuration_module.js
// module id = 3394008886350071
// module chunks = 1